import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./Login.css";

function Login() {
  const { user, signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (user) {
    return <Navigate to={location.state?.from || "/dashboard"} replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      await signIn(email, password);
      navigate(location.state?.from || "/dashboard", { replace: true });
    } catch {
      setError("Sign-in failed. Check your email and password.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="login-page">
      <div className="login-shell">
        <section className="login-intro">
          <div className="login-mark">S</div>
          <span className="login-eyebrow">STRIDES AAR</span>
          <h1>Turn experience into better work.</h1>
          <p>
            Access your After Action Review library, track improvement actions,
            and keep every lesson visible to the teams who need it.
          </p>
          <div className="login-intro-footer">
            <span>SAFER</span>
            <span>SMARTER</span>
            <span>STRONGER</span>
          </div>
        </section>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-form-heading">
            <span className="login-form-kicker">AAR SYSTEM</span>
            <h2>Welcome back</h2>
            <p>Sign in to continue to your workspace.</p>
          </div>

          <div className="login-field">
            <label htmlFor="email">Work email</label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              placeholder="you@company.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </div>

          <div className="login-field">
            <div className="login-label-row">
              <label htmlFor="password">Password</label>
              <span>Secure access</span>
            </div>
            <div className="password-field">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                autoComplete="current-password"
                placeholder="Enter your password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword((visible) => !visible)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {error && <p className="login-error" role="alert">{error}</p>}

          <button className="login-submit" type="submit" disabled={isSubmitting}>
            {isSubmitting ? (
              <span className="login-loading-label">
                <span className="loading-spinner" aria-hidden="true"></span>
                Verifying access
              </span>
            ) : (
              <span>Enter workspace</span>
            )}
            <span aria-hidden="true">-&gt;</span>
          </button>

          <p className="login-footnote">
            Authorized team members only. Your credentials are protected by Firebase Authentication.
          </p>
        </form>
      </div>
    </main>
  );
}

export default Login;
